import React from 'react';
import { Box, SecondaryButton } from '@src/shared/ui';
import { PrimaryButton } from '@src/shared/ui';
import { DescriptionContent, ImgFeedback, TitleContent } from '../atoms';

export interface FeedbackContentButtonProps {
  onClick: () => void;
  text: string;
  loading?: boolean;
  disabled?: boolean;
}

type FeedbackContentProps = {
  title: string;
  description: string;
  primaryButton: FeedbackContentButtonProps;
  secondaryButton: FeedbackContentButtonProps;
};

export const FeedbackContent: React.FC<FeedbackContentProps> = ({
  title,
  description,
  primaryButton,
  secondaryButton,
}) => {
  return (
    <Box
      className={`
            mt-10
            mb-14
            col-span-4
            md:mt-16
            md:col-span-6
            md:mx-0
            md:my-auto
          `}
    >
      <Box>
        <ImgFeedback />
        <TitleContent className='mt-4 text-2xl sm:text-4xl'>
          {title}
        </TitleContent>
        <DescriptionContent className='mt-3'>{description}</DescriptionContent>
      </Box>

      {primaryButton && (
        <PrimaryButton
          loading={primaryButton.loading}
          onClick={primaryButton.onClick}
          className={`
            mt-8
            col-start-1
            col-end-5
            w-full
            md:min-w-[295.2px]
            md:max-w-[405px]

            md:md-0
            md:mx-0
          `}
        >
          {primaryButton.text}
        </PrimaryButton>
      )}

      {secondaryButton && (
        <SecondaryButton
          onClick={secondaryButton.onClick}
          className={`
            mx-6
            mt-10
            col-start-1
            col-end-5
            min-w-[295.2px]

            md:mx-0
          `}
        >
          {secondaryButton.text}
        </SecondaryButton>
      )}
    </Box>
  );
};
